﻿import React, { useState } from 'react';
import { CasChemical } from '../models/cas-chemical';
import { CrudFunctions } from '../utilities/crud-functions';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';
import GlobalDialog from './Modal/GlobalDialog';

import { Button } from 'devextreme-react/button';

import {
    TextBox,
    CheckBox,
} from 'devextreme-react';

export interface Props {
    casNumber?: string;
    onCasSave?: (e: CasChemical) => void;
}

export default function CasDataLoader(props: Props) {
    const [chemical, setChemical] =
        useState<CasChemical>();

    const [casNumber, setCasNumber] =
        useState<string>(props.casNumber);

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>()

    let molecularImage = chemical && chemical.image ? chemical.image : '';

    return (
        <div className="pw-form-section">
            <div className="pw-comp-row">
                <div className="pw-grow">
                    <div className="pw-form-unit pw-comp-15">
                        <label className="pw-form-unit-label">CAS#</label>
                        <TextBox placeholder="cas number" value={casNumber ? casNumber : ''}
                            onValueChanged={onCasNumberChanged} />
                    </div>
                </div>

                <div className="pw-right-align-content pw-margin-top-1 pw-margin-right-05">
                    <div>
                        <Button type="success" className="pw-button"
                            onClick={onGetCasDataClick} text="Get CAS Data" />
                        <Button type="success" className="pw-button" disabled={true}
                            onClick={onSaveCasDataClick} text="Save CAS Data" />
                    </div>
                </div>
            </div>

            <div className="pw-comp-row pw-margin-bottom-1">
                <div className="pw-form-unit">
                    <div className="pw-form-unit-label">All checked items will be saved.</div>
                </div>
            </div>

            <div className="pw-comp-row pw-grow">
                <div className="pw-form-unit pw-right-align-content pw-vertical-center">
                    <CheckBox id="saveName"
                        value={chemical ? chemical.saveName : false}
                        onValueChanged={onSaveValueChanged} />
                </div>
                <div className="pw-form-unit pw-grow">
                    <div className="pw-form-unit-label">Name</div>
                    <div className="pw-readonly-label">{chemical && chemical.name ?
                        chemical.name : ''}</div>
                </div>
            </div>

            <div className="pw-comp-row pw-grow">
                <div className="pw-form-unit pw-right-align-content pw-vertical-center">
                    <CheckBox id="saveMolecularFormula"
                        value={chemical ? chemical.saveMolecularFormula : false}
                        onValueChanged={onSaveValueChanged} />
                </div>
                <div className="pw-form-unit pw-grow">
                    <div className="pw-form-unit-label">Molecular Formula</div>
                    <div className="pw-readonly-label">{chemical && chemical.molecularFormula
                        ? chemical.molecularFormula : ''}</div>
                </div>
            </div>

            <div className="pw-comp-row pw-grow">
                <div className="pw-form-unit pw-right-align-content pw-vertical-center">
                    <CheckBox id="saveSmile"
                        value={chemical ? chemical.saveSmile : false}
                        onValueChanged={onSaveValueChanged} />
                </div>
                <div className="pw-form-unit pw-grow">
                    <div className="pw-form-unit-label">SMILES</div>
                    <div className="pw-readonly-label">{chemical && chemical.smile ?
                        chemical.smile : ''}</div>
                </div>
            </div>

            <div className="pw-comp-row pw-grow">
                <div className="pw-form-unit pw-right-align-content pw-vertical-center">
                    <CheckBox id="saveMolecularMass"
                        value={chemical ? chemical.saveMolecularMass : false}
                        onValueChanged={onSaveValueChanged} />
                </div>
                <div className="pw-form-unit pw-grow">
                    <div className="pw-form-unit-label">Molecular Mass</div>
                    <div className="pw-readonly-label">{chemical && chemical.molecularMass ?
                        chemical.molecularMass : ''}</div>
                </div>
            </div>

            <div className="pw-comp-row pw-grow">
                <div className="pw-form-unit pw-right-align-content pw-vertical-center">
                    <CheckBox id="saveInChIKey"
                        value={chemical ? chemical.saveInChIKey : false}
                        onValueChanged={onSaveValueChanged} />
                </div>
                <div className="pw-form-unit pw-grow">
                    <div className="pw-form-unit-label">Inchi Key</div>
                    <div className="pw-readonly-label">{chemical && chemical.inchiKey ?
                        chemical.inchiKey : ''}</div>
                </div>
            </div>

            {/* LEAVE FOR NOW - WE WILL NEED THESES LATER
                <div className="pw-comp-row pw-grow">
                    <div className="pw-form-unit pw-grow">
                        <div className="pw-form-unit-label">Synonyms</div>

                        <div className="pw-readonly-label">{this.state.chemical && this.state.chemical.synonyms ?
                            this.state.chemical.synonyms.map((item, i) => <p key={i.toString()}
                                className="validation-text">{i + 1}.{item}</p>) : ''}</div>
                        
                    </div>

                    <div className="pw-form-unit pw-comp-5 pw-right-align-content pw-vertical-center">
                        <CheckBox id="saveSynonyms"
                            value={this.state.chemical ? this.state.chemical.saveSynonyms : false}
                            onValueChanged={this.onSaveValueChanged} />
                    </div>
                </div>
                */}

            <div className="pw-comp-row pw-grow">
                <div className="pw-form-unit pw-right-align-content pw-vertical-center">
                    <CheckBox id="saveImage"
                        value={chemical ? chemical.saveImage : false}
                        onValueChanged={onSaveValueChanged} />
                </div>
                <div className="pw-form-unit pw-grow">
                    <label className="pw-form-unit-label">Image</label>
                    {molecularImage &&
                        <div>
                            <img className="dialog-image" src={`data:image/svg+xml;utf8,${molecularImage}`} alt="molecular" />
                        </div>
                    }
                </div>
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

        </div>
    );

    function onCasNumberChanged(e: any) {
        setCasNumber(e.value);
    }

    function onSaveValueChanged(e: any) {
        const caller = e.element.id;
        
        setChemical({ ...chemical, [caller]: e.value })
    }

    function onGetCasDataClick() {
        loadCasData();
    }

    async function onSaveCasDataClick() {
        if (chemical && props.onCasSave)
            props.onCasSave(chemical);
    }

    async function loadCasData() {
        if (casNumber) {
            await CrudFunctions.getData(`externaldata/casdata/${casNumber}`)
                .then((data) => {
                    console.log("returned CAS data");
                    console.log(data);

                    let casChemical = data as CasChemical;

                    if (casChemical) {
                        casChemical.saveName = false;
                        casChemical.saveInChIKey = false;
                        casChemical.saveMolecularFormula = false;
                        casChemical.saveSmile = false;
                        casChemical.saveMolecularMass = false;
                        casChemical.saveImage = false;
                        casChemical.saveInChIKey = false;
                        casChemical.saveSynonyms = false;

                        setChemical(casChemical);
                    }
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving CAS Data");
                })
        }
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
}
